<template>
  <div class="auth-wrapper" id="check-scroll" @scroll="checkScroll()">
    <b-row class="m-0">
      <b-col cols="12" md="12" class="auth-wrapper__header">
        <span
          class="cursor--pointer icon-hover"
          :class="{ 'visibility--hidden': !rightIcon }"
          @click="handleRightIcon"
        >
          <mdicon :name="rightIcon" size="20" />
        </span>
        <span
          class="cursor--pointer icon-hover"
          :class="{ 'visibility--hidden': !leftIcon }"
          v-b-tooltip.hover
          :title="leftIconTooltip"
          @click="handleLeftIcon"
        >
          <mdicon :name="leftIcon" size="20" />
        </span>
      </b-col>
      <b-col v-if="showLogo" cols="12" md="12" class="auth-wrapper__logo">
        <b-img :src="$config.images.tinyLogo" width="75" height="auto" />
        <div class="auth-wrapper__title" v-html="$lang.project_title" />
      </b-col>
      <b-col cols="12" md="12" class="auth-wrapper__label">{{ label }}</b-col>
      <b-col cols="12" md="12" class="auth-wrapper__main">
        <div class="auth-wrapper__body">
          <slot name="alertBox" />
          <slot name="main" />
        </div>
        <div
          class="auth-wrapper__buttons"
          :class="{ 'box-shadow--floating-button': showFooterShadow }"
        >
          <slot name="button" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ref, toRefs } from "vue";
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    rightIcon: {
      type: String,
      default: "",
    },
    leftIcon: {
      type: String,
      default: "",
    },
    leftIconTooltip: {
      type: String,
      default: "",
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { label, rightIcon, leftIcon, leftIconTooltip, showLogo } =
      toRefs(props);

    const showFooterShadow = ref(false);
    const checkScroll = () => {
      const el = document.getElementById("check-scroll");
      const calcScroll = el.scrollHeight - el.scrollTop;
      showFooterShadow.value = calcScroll > el.clientHeight;
    };

    const handleRightIcon = () => emit("handleRightIcon");
    const handleLeftIcon = () => emit("handleLeftIcon");

    // return data to be used in template
    return {
      label,
      rightIcon,
      leftIcon,
      leftIconTooltip,
      showLogo,
      showFooterShadow,
      checkScroll,
      handleRightIcon,
      handleLeftIcon,
    };
  },
};
</script>
